export default __webpack_public_path__ + "static/media/icon1.98d813b2.png";